export const TYPOGRAPHY = {
  TITLE: 'title',
  TITLE_LITE: 'title-lite',
  TITLE_LITE_PURPLE: 'title-lite-purple',
  SUBTITLE: 'subtitle',
  SUBTITLE_BLACK: 'subtitle-black',
  SUBTITLE_BIG: 'subtitle-big',
  SUBTITLE_BIG_BLACK: 'subtitle-big-black',
  PARA: 'para',
  PARA_BOLD: 'para-bold',
  PARA_PURPLE: 'para-purple',
  INTERNAL_LINK: 'internal-link',
};

export const TYPOGRAPHY_COLOR = {
  BLACK: 'black',
  GREY: 'grey',
  RED: 'red',
  PRIMARY_PURPLE: 'primaryPurple',
  DEEP_PURPLE: 'deepPurple',
  BLUE: 'blue',
  WHITE: 'white',
  WHITE_NT: 'white-nt',
  BLACK_NT: 'black-nt',
};

export const TYPOGRAPHY_STYLE = {
  BOLD: 'bold',
  SEMI_BOLD: 'semi-bold',
  REGULAR: 'regular',
};

export const TYPOGRAPHY_SIZE = {
  12: '12',
  14: '14',
  16: '16',
  18: '18',
  20: '20',
  22: '22',
  24: '24',
  26: '26',
  28: '28',
  30: '30',
  32: '32',
  34: '34',
  36: '36',
};

export const FAQ_CONFIG = {
  INPUT: {
    textareaProps: {
      placeholder: 'Type something here...',
      type: 'textarea',
      rows: 6,
    },
  },
};
